import { Link } from 'react-router-dom';
import { Mic } from 'lucide-react';
import SocialLinks from '@/components/SocialLinks';

const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] border-t border-neutral-800 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center mb-4">
              <img 
                src="/logo-full.png" 
                alt="EpisodeKit" 
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-neutral-500 max-w-md">
              Transform your podcast episodes into professional show notes, blog posts, and social media content with AI.
            </p>
            <div className="mt-6">
              <p className="text-xs uppercase tracking-widest text-neutral-500 mb-3 font-semibold">
                Follow EpisodeKit
              </p>
              <SocialLinks size="md" />
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Product</h4>
            <ul className="space-y-2">
              <li><Link to="/#features" className="text-neutral-400 hover:text-white transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="text-neutral-400 hover:text-white transition-colors">Pricing</Link></li>
              <li><Link to="/episode-examples" className="text-neutral-400 hover:text-white transition-colors" data-testid="footer-examples-link">Examples</Link></li>
              <li><Link to="/blog" className="text-neutral-400 hover:text-white transition-colors" data-testid="footer-blog-link">Blog</Link></li>
              <li><Link to="/about" className="text-neutral-400 hover:text-white transition-colors" data-testid="footer-about-link">About</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/terms" className="text-neutral-400 hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-neutral-400 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/fair-use" className="text-neutral-400 hover:text-white transition-colors">Fair Use Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-neutral-800 text-center text-neutral-500 text-sm">
          <p>&copy; {new Date().getFullYear()} EpisodeKit. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
